/**
 * Module kya
 * @module app.kya
 */
define([
    'angular',
    'moment',
    'bootstrap',
    'ui-bootstrap4',
    'angular-ui-notification',
    'angular-fr',
    'modules/kya/list/index',
    'modules/kya/contracts/index',
    'modules/kya/edition/index',
    'modules/kya/jds/index'
], function(angular, moment) {


    angular.module('app.kya', ['app.kya.list', 'app.kya.contracts', 'app.kya.edition', 'app.kya.jds']);
});
